import React from "react";
import { Typography } from "@material-ui/core";
import { useStyles } from "./LoginText.style";

interface Props {
  title?: string;
  contents?: string;
}

const LoginText = (props: Props) => {
  const { title, contents } = props;
  const classes = useStyles();

  return (
    <>
      {title && (
        <Typography variant="h5">
          <div className={classes.titleText}>{title}</div>
        </Typography>
      )}
      {contents && (
        <Typography variant="subtitle1">
          <div className={classes.descriptionText}>{contents}</div>
        </Typography>
      )}
    </>
  );
};

export default LoginText;
